<style lang="scss">
.basechannel .ivu-form-item {
    margin-bottom: 10px;
}
.basechannel .ivu-form-item-content {
    line-height: 32px;
}
.chalbasetable {
    margin-left: 120px;
    margin-bottom: 15px;
    .vview-table td,
    .vview-table th {
        padding-left: 15px;
    }
}
</style>
<template>
    <div>
        <Form
            :label-width="130"
            :model="formData"
            class="margin-15 clearfix basechannel"
            ref="baseform"
        >
            <Col span="24">
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.product.product_type', {
                                defaultValue: '产品类型',
                            })
                        "
                        v-if="alltype == 'query' || alltype == 'edit'"
                    >
                        <div>{{ formData.type | filterType }}</div>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.product.product_type', {
                                defaultValue: '产品类型',
                            })
                        "
                        prop="type"
                        :rules="required"
                    >
                        <Select
                            v-model="formData.type"
                            @on-change="changetable(formData.type)"
                        >
                            <Option value="single">{{
                                $t("erp.channel.single_product", {
                                    defaultValue: "简单产品",
                                })
                            }}</Option>
                            <Option value="bundle">{{
                                $t("erp.channel.bundle_product", {
                                    defaultValue: "组合产品",
                                })
                            }}</Option>
                            <Option value="virtual">{{
                                $t("erp.channel.virtual_product", {
                                    defaultValue: "虚拟产品",
                                })
                            }}</Option>
                        </Select>
                        <span class="color-error line-28">{{
                            $t("erp.channel.bundle_product_attention", {
                                defaultValue:
                                    "组合产品为一个Seller SKU对应多个ERP SKU的情况，虚拟产品可以不维护ERP SKU对应关系",
                            })
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('global.common.channel', {
                                defaultValue: '渠道',
                            })
                        "
                        v-if="alltype == 'query' || alltype == 'edit'"
                    >
                        <div>{{ formData.accountFlag }}</div>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('global.common.channel', {
                                defaultValue: '渠道',
                            })
                        "
                        prop="accountFlag"
                        :rules="required"
                    >
                        <Select
                            v-model="formData.accountFlag"
                            filterable
                            clearable
                            @on-change="changeChannel(formData.accountFlag)"
                        >
                            <Option
                                v-for="item in getAccount"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="formData.type != 'virtual'">
                <Col span="12">
                    <FormItem
                        label="ERPSKU"
                        v-if="alltype == 'query' || alltype == 'edit'"
                    >
                        {{ formData.erpSku }}
                    </FormItem>
                    <FormItem
                        label="ERPSKU"
                        prop="erpSku"
                        :rules="required"
                        v-else
                    >
                        <erpSkuInput
                            v-bind:value="formData.erpSku"
                            erpskutype="manage"
                            @on-data="handleErpSku"
                            @on-change="searcherpsku(formData.erpSku)"
                        ></erpSkuInput>
                        <span class="color-error">{{
                            $t("erp.channel.attention_2", {
                                defaultValue:
                                    "组合产品只能选择同一个项目的ERP SKU",
                            })
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('global.common.organization', {
                                defaultValue: '组织',
                            })
                        "
                    >
                        {{ formData.orgName }}
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="showzuhe">
                <Col span="12">
                    <vTable
                        class="chalbasetable"
                        :columns="columns"
                        :data="formList"
                        size="small"
                        ref="table"
                        border
                        stripe
                    ></vTable>
                </Col>
            </Col>

            <Col span="24">
                <Col span="12">
                    <FormItem
                        label="SellerSKU"
                        v-if="alltype == 'query' || alltype == 'edit'"
                    >
                        {{ formData.sellerSku }}
                    </FormItem>
                    <FormItem
                        label="SellerSKU"
                        prop="sellerSku"
                        :rules="required"
                        v-else
                    >
                        <Input v-model="formData.sellerSku"></Input>
                        <span class="color-error">{{
                            $t("erp.channel.product_in_channel_sku", {
                                defaultValue: "产品在渠道上的SKU",
                            })
                        }}</span>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('erp.product.product_line', {
                                defaultValue: '项目',
                            })
                        "
                    >
                        {{
                            formData.lineId
                                | transferText("name", productLineAll)
                        }}
                    </FormItem>
                </Col>
            </Col>

            <Col span="24" v-if="formData.type != 'virtual'">
                <Col span="12">
                    <FormItem
                        v-if="alltype == 'query'"
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            formData.skuOrderType == 0
                                ? $t("erp.channel.auto", {
                                      defaultValue: "自动",
                                  })
                                : $t("erp.channel.manual", {
                                      defaultValue: "手动",
                                  })
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.b2c.shipping_method', {
                                defaultValue: '发货方式',
                            })
                        "
                        prop="skuOrderType"
                        :rules="required"
                    >
                        <div>
                            <RadioGroup v-model="formData.skuOrderType">
                                <Radio :label="0">
                                    <Icon type="social-yes"></Icon>
                                    <span>{{
                                        $t("erp.channel.auto", {
                                            defaultValue: "自动",
                                        })
                                    }}</span>
                                </Radio>
                                <Radio :label="1">
                                    <Icon type="social-no"></Icon>
                                    <span>{{
                                        $t("erp.channel.manual", {
                                            defaultValue: "手动",
                                        })
                                    }}</span>
                                </Radio>
                            </RadioGroup>
                        </div>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        :label="
                            $t('global.common.currency', {
                                defaultValue: '币种',
                            })
                        "
                        v-if="alltype == 'query' || alltype == 'edit'"
                    >
                        {{ formData.currencyCode }}
                    </FormItem>
                    <FormItem
                        :label="
                            $t('global.common.currency', {
                                defaultValue: '币种',
                            })
                        "
                        prop="currencyCode"
                        :rules="required"
                        v-else
                    >
                        {{ formData.currencyCode }}
                    </FormItem>
                </Col>
            </Col>
            <Col span="24" v-if="formData.type != 'virtual'">
                <Col span="12">
                    <FormItem
                        v-if="alltype == 'query'"
                        :label="
                            $t('erp.channel.up_down_status', {
                                defaultValue: '上下架状态',
                            })
                        "
                    >
                        <span class="font-weight">{{
                            formData.saleState | filterSalestate
                        }}</span>
                    </FormItem>
                    <FormItem
                        v-else
                        :label="
                            $t('erp.channel.up_down_status', {
                                defaultValue: '上下架状态',
                            })
                        "
                        prop="saleState"
                        :rules="required"
                    >
                        <Select v-model="formData.saleState">
                            <Option value="Hit Shelve">{{
                                $t("erp.channel.up_staff", {
                                    defaultValue: "上架",
                                })
                            }}</Option>
                            <Option value="Off Shelve">{{
                                $t("erp.channel.temp_down_staff", {
                                    defaultValue: "临时下架",
                                })
                            }}</Option>
                            <Option value="Not Sell">{{
                                $t("erp.channel.down_staff", {
                                    defaultValue: "下架",
                                })
                            }}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem v-if="alltype == 'query'" label="Asin">
                        <span class="font-weight">{{ formData.asin }}</span>
                    </FormItem>
                    <FormItem v-else label="Asin">
                        <Input v-model="formData.asin"></Input>
                        <span class="color-error">{{
                            $t("erp.channel.product.require_amazon_channel", {
                                defaultValue: "亚马逊渠道必填",
                            })
                        }}</span>
                    </FormItem>
                </Col>
            </Col>
        </Form>
    </div>
</template>

<script>
import { HttpGetCodeByLineId } from "@/service/products/channel";
import { mapState, mapGetters } from "vuex";
import erpSkuInput from "@components/templates/erpskuinput.vue";
let that = this;
export default {
    props: ["alltype", "basedata"],
    components: {
        erpSkuInput,
    },
    data() {
        that = this;
        return {
            showzuhe: false,
            formData: {
                lineId: "",
                saleState: "Hit Shelve",
                type: "single",
                isInsurance: "Y",
                skuOrderType: 0,
                isPush: "N",
                handelingTime: 3,
                pushProportion: "",
                orgName: "",
                orgId: "",
            },
            warehouseList: [],
            formList: [],
            loading1: false,
            erpSkusList: [],
            required: [
                {
                    required: true,
                    message: this.$t("global.common.required", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],
        };
    },
    computed: {
        ...mapState("boss", ["productLineAll", "accountTypes", "accounts"]),
        ...mapGetters("diction", ["getNewAccountList"]),
        ...mapGetters("dictionary", ["getOrgList"]),
        getAccount() {
            return this.getNewAccountList.filter((item) => {
                return item.attach.status != "inactive";
            });
        },
        columns() {
            const _this = this;
            const showwidth = this.alltype == "add";
            return [
                {
                    title: "ERPSKU",
                    key: "erpSku",
                    render(h, { row }) {
                        if (_this.alltype == "add") {
                            return h("Input", {
                                props: {
                                    size: "small",
                                    value: row.erpSku,
                                    readonly: true,
                                },
                                on: {
                                    input: (event) => {
                                        row.erpSku = event;
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.erpSku}</div>;
                        }
                    },
                },
                {
                    title: this.$t("erp.product.customise_product_code", {
                        defaultValue: "自定义产品编码",
                    }),
                    render(h, { row }) {
                        return (
                            <div>{row.erpSkuCode ? row.erpSkuCode : "--"}</div>
                        );
                    },
                },
                {
                    title: this.$t("fbb.accountmanage.amount", {
                        defaultValue: "数量",
                    }),
                    key: "qty",
                    width: 150,
                    render(h, { row, index }) {
                        if (_this.alltype == "add") {
                            return h("InputNumber", {
                                props: {
                                    size: "small",
                                    min: 1,
                                    value: row.qty,
                                },
                                on: {
                                    input: (event) => {
                                        row.qty = event;
                                        // console.log(event)
                                        _this.formList[index] = row;
                                    },
                                },
                            });
                        } else {
                            return <div>{row.qty}</div>;
                        }
                        // return <div>{row.qty}</div>
                    },
                },
                {
                    title: this.$t("global.common.operate", {
                        defaultValue: "操作",
                    }),
                    width: _this.alltype == "add" ? 80 : 0,
                    render(h, { row, index }) {
                        // console.log(_this.alltype=='add')
                        if (_this.alltype == "add") {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                        },
                                        on: {
                                            click: () => {
                                                _this.remove(index, row.id);
                                            },
                                        },
                                    },
                                    this.$t("global.common.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        } else {
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "error",
                                            size: "small",
                                            disabled: true,
                                        },
                                        on: {
                                            click: () => {},
                                        },
                                    },
                                    this.$t("global.common.delete", {
                                        defaultValue: "删除",
                                    })
                                ),
                            ]);
                        }
                    },
                },
            ];
        },
    },
    methods: {
        handleErpSku(row) {
            this.$set(this.formData, "erpSku", row.erpSku);
            this.erpSkusList = [
                {
                    name: row.erpSku,
                    id: row.id,
                    title: row.nameEn,
                    lineId: row.lineId,
                    orgId: row.orgId,
                },
            ];
        },
        // 切换渠道，换对应的币种
        changeChannel(value) {
            // console.log(value)
            let objitem;
            objitem = this.getNewAccountList.filter(
                (item) => item.value == value
            );
            // console.log(objitem)
            this.formData.currencyCode = objitem[0].attach.currency;

            this.$emit("on-currency", objitem[0].attach.currency);
        },
        async handledata() {
            this.formData = this.basedata;
            this.formList = this.basedata.productChannelRelateList;
            let productList = this.formList.map((item) => {
                return item.productId;
            });
            // console.log(productList,'productList')
            if (productList.length > 0) {
                await HttpGetCodeByLineId({
                    productIds: productList.join(","),
                }).then((res) => {
                    res.data.map((item) => {
                        this.formList.map((formItem) => {
                            if (item.erpSku === formItem.erpSku) {
                                formItem.erpSkuCode = item.erpSkuCode;
                            }
                        });
                    });
                });

                if (this.alltype != "add") {
                    if (this.formData.type == "bundle") {
                        this.showzuhe = true;
                    }
                }
            }
        },
        clickblur(type) {
            if (type == false) {
                if (!this.formData.erpSku) {
                    this.$refs.zierpselect.clearSingleSelect();
                }
            }
        },
        searcherpsku(erpSku) {
            if (erpSku) {
                let productsItem = this.erpSkusList.filter((item) => {
                    return item.name == erpSku;
                });

                const hasConflict = this.formList.some(
                    (item) => item.orgId !== productsItem[0].orgId
                );

                if (hasConflict) {
                    // 如果存在不一致的 orgId，弹出报错提示并终止后续操作
                    this.$VMessage.error(
                        "当前选择的组织与列表中已有的组织不一致，请检查！"
                    );
                    return;
                }

                // 项目填入
                this.formData.lineId = productsItem[0].lineId;
                this.formData.orgId = productsItem[0].orgId;
                const org = this.getOrgList.find(
                    (item) => item.value === productsItem[0].orgId
                );
                this.formData.orgName = org.label;

                if (productsItem.length > 0) {
                    let obj = {
                        erpSku: productsItem[0].name,
                        qty: 0,
                        productId: productsItem[0].id,
                        lineId: productsItem[0].lineId,
                        orgId: productsItem[0].orgId,
                    };
                    this.formList.push(obj);
                }
            }
        },
        remove(index) {
            this.formList.splice(index, 1);
            this.formData.lineId =
                this.formList[this.formList.length - 1].lineId;
        },
        changetable(type) {
            if (type == "bundle") {
                this.showzuhe = true;
            } else {
                this.showzuhe = false;
            }
        },
        async validate() {
            const bool = await this.$refs["baseform"].validate();
            if (!bool) {
                this.$VMessage.warning(
                    this.$t("global.form.require", {
                        defaultValue: "请填写必填项",
                    })
                );
            }
            return bool;
        },
    },
    filters: {
        filterType(type) {
            switch (type) {
                case "single":
                    return that.$t("erp.channel.single_product", {
                        defaultValue: "简单产品",
                    });
                    break;
                case "bundle":
                    return that.$t("erp.channel.bundle_product", {
                        defaultValue: "组合产品",
                    });
                    break;
                case "virtual":
                    return that.$t("erp.channel.virtual_product", {
                        defaultValue: "虚拟产品",
                    });
                    break;
            }
        },
        transferText(val, textKey, list = [], key = "id") {
            let text = "";
            list.forEach((item) => {
                if (item[key] === val) {
                    text = item[textKey];
                }
            });
            return text;
        },
        filterSalestate(type) {
            switch (type) {
                case "Hit Shelve":
                    return that.$t("erp.channel.up_staff", {
                        defaultValue: "上架",
                    });
                    break;
                case "Off Shelve":
                    return that.$t("erp.channel.temp_down_staff", {
                        defaultValue: "临时下架",
                    });
                    break;
                case "Not Sell":
                    return that.$t("erp.channel.down_staff", {
                        defaultValue: "下架",
                    });
                    break;
            }
        },
    },
    watch: {
        basedata() {
            this.handledata();
        },
    },
};
</script>
